/**
 * Utility functions to convert Figma RGB values to CSS colors
 * Figma uses 0-1 range for RGB values
 */

export const figmaRgbToHex = (r: number, g: number, b: number): string => {
  const toHex = (value: number) => {
    const hex = Math.round(value * 255).toString(16);
    return hex.length === 1 ? '0' + hex : hex;
  };
  return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
};

export const figmaRgba = (r: number, g: number, b: number, a = 1): string => {
  return `rgba(${Math.round(r * 255)}, ${Math.round(g * 255)}, ${Math.round(b * 255)}, ${a})`;
};

// Color constants extracted from Figma design
export const Colors = {
  // Background colors
  darkBackground: '#1B170C', // rgb(0.10588235408067703, 0.09019608050584793, 0.0470588244497776)
  lightBackground: '#FFFAF2', // rgb(1, 0.9803921580314636, 0.9490196108818054)
  darkSectionBg: '#211A0F', // rgb(0.12941177189350128, 0.10196078568696976, 0.03529411926865578)
  
  // Text colors
  white: '#FFFFFF',
  lightGray: '#E8E8E8', // rgb(0.9098039269447327, 0.9098039269447327, 0.9098039269447327)
  darkText: '#1B170C', // rgb(0.10588235408067703, 0.09019608050584793, 0.0470588244497776)
  mediumText: '#211A0F', // rgb(0.12941177189350128, 0.10196078568696976, 0.03529411926865578)
  lightText: '#39342A', // rgb(0.22397373616695404, 0.2000739723443985, 0.14141087234020233)
  
  // Button/Accent colors
  buttonBg: '#FDE4BA', // rgb(0.9916666746139526, 0.8944193124771118, 0.727222204208374)
  buttonBorder: '#211A0F', // rgb(0.12941177189350128, 0.10196078568696976, 0.03529411926865578)
  
  // Card colors
  cardDark: '#45302D', // rgb(0.2721153497695923, 0.20402491092681885, 0.106752909719944)
  cardMedium: '#755656', // rgb(0.4588235318660736, 0.33725491166114807, 0.1764705926179886)
  cardLight: '#4C4330', // rgb(0.2980392277240753, 0.26274511218070984, 0.18431372940540314)
  
  // Border colors
  borderGray: '#6E6E6E', // rgb(0.4313725531101227, 0.4313725531101227, 0.4313725531101227)
  borderLight: '#5A5447', // rgb(0.35686275362968445, 0.3294117748737335, 0.2549019753932953)
  
  // Pattern colors (from Niyyah pattern gradients)
  patternGreen: '#66CC99', // rgb(0.4000000059604645, 0.800000011920929, 0.6000000238418579)
  patternPurple: '#663399', // rgb(0.4000000059604645, 0.20000000298023224, 0.5960784554481506)
  patternOrange: '#F8AD42', // rgb(0.9725490212440491, 0.6784313917160034, 0.25882354378700256)
};
